export default __webpack_public_path__ + "static/media/exportacao-temporaria.2d8b96af.jpg";